import { validateEmail } from "utils/helperFunctions";

interface ValidationValues {
  displayName: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export function validateInput(values: ValidationValues) {
  const errs: Record<string, string> = {};
  const { displayName, email, password, confirmPassword } = values;
  const alphaNumRegex = /[^a-z\d]/i;

  if (alphaNumRegex.test(displayName)) {
    errs.displayName = "Display name can only be alphanumeric characters";
  } else if (displayName.length < 3) {
    errs.displayName = "Display name must be at least 3 characters";
  } else if (displayName.length > 20) {
    errs.displayName = "Display name cannot be more than 20 characters";
  }
  if (!validateEmail(email)) {
    errs.email = "Please enter a valid email";
  }
  if (password === "") {
    errs.password = "Please enter a password";
  }
  if (password !== confirmPassword) {
    errs.confirmPassword = "Passwords do not match";
  }

  return errs;
}
